import ScrollReveal from '@/components/base/ScrollReveal';
import SectionHeading from '@/components/base/SectionHeading';
import { executionMistakes } from '@/mocks/forexTrading';

export default function ExecutionMistakes() {
  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="ผิดพลาดบ่อย"
          title="6 จุดที่คนเพิ่งเริ่มมักพลาดตอนกดออเดอร์"
          subtitle="ส่วนใหญ่ไม่ได้ผิดเพราะวิเคราะห์ผิด แต่ผิดเพราะขั้นตอนตอนกดกับตอนปิด ไม่มีวินัยพอ"
        />

        <div className="mt-9 grid grid-cols-1 gap-4 md:grid-cols-2">
          {executionMistakes.map((item, index) => (
            <ScrollReveal key={item.title} delay={(index % 2) * 70} className="h-full">
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-start gap-3">
                  <span className="font-num mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-semibold text-accent-800">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950">
                    {item.title}
                  </h3>
                </div>

                <div className="mt-4 flex items-start gap-2">
                  <span className="mt-0.5 shrink-0 rounded-sm bg-background-100 px-1.5 py-0.5 text-[11px] font-medium text-foreground-600">
                    อาการ
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-600">{item.symptom}</p>
                </div>

                <div className="mt-auto flex items-start gap-2 rounded-md border-l-2 border-l-primary-500 bg-primary-50/70 px-3 py-2.5">
                  <i className="ri-lightbulb-line mt-0.5 shrink-0 text-base text-primary-700" />
                  <p className="text-sm leading-relaxed text-foreground-800">{item.fix}</p>
                </div>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}